import React from 'react';

/**
 * Context Indicator Component
 * Zobrazuje aktivní kontext konverzace a umožňuje reset
 */
export default function ContextIndicator({ contextMessages, onClear }) {
  if (!contextMessages || contextMessages.length === 0) {
    return null;
  }

  // Get summary of context
  const getContextSummary = () => {
    const topics = [];

    contextMessages.forEach(msg => {
      if (msg.type === 'user') {
        // Extract key topics from user messages
        const query = msg.content.toLowerCase();

        if (query.includes('banner')) topics.push('bannery');
        if (query.includes('google ads') || query.includes('ppc')) topics.push('Google Ads');
        if (query.includes('mobile') || query.includes('mobil')) topics.push('mobile');
        if (query.includes('desktop')) topics.push('desktop');
        if (query.includes('konverz')) topics.push('konverze');
        if (query.includes('da_rtb') || query.includes('rtb')) topics.push('DA_rtb');
      }
    });

    return [...new Set(topics)]; // Remove duplicates
  };

  const topics = getContextSummary();
  const messageCount = contextMessages.filter(m => m.type === 'user').length;

  return (
    <div className="mb-4 bg-green-500 text-white p-3 rounded-lg flex justify-between items-center shadow-sm">
      <div className="flex items-center gap-3 flex-1">
        <span className="material-symbols-outlined text-xl">psychology</span>
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold opacity-90">Kontext konverzace:</span>
          <div className="flex flex-wrap gap-2">
            {topics.length > 0 ? (
              topics.map((topic, idx) => (
                <span
                  key={idx}
                  className="bg-white/30 px-2 py-0.5 rounded-full text-xs font-medium"
                >
                  {topic}
                </span>
              ))
            ) : (
              <span className="text-sm opacity-95">
                {messageCount} {messageCount === 1 ? 'dotaz' : 'dotazy'}
              </span>
            )}
          </div>
        </div>
      </div>
      <button
        className="px-3 py-1.5 bg-white/20 border border-white/50 rounded hover:bg-white/30 transition-colors flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap"
        onClick={onClear}
        title="Začít novou konverzaci"
      >
        <span className="material-symbols-outlined text-sm">refresh</span>
        Nová konverzace
      </button>
    </div>
  );
}
